import React from 'react';
import { Bell, X, Clock, Calendar } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationContext';

const UnreadNotificationReminder = () => {
  const {
    unreadCount,
    showReminder,
    setShowReminder,
    dismissReminder,
    dismissReminderForToday,
    openNotificationPanel
  } = useNotifications();

  if (!showReminder || unreadCount === 0) {
    return null;
  }

  const handleViewNotifications = () => {
    setShowReminder(false);
    openNotificationPanel();
    // Bildirim panelini açmak için event dispatch et
    window.dispatchEvent(new CustomEvent('openNotificationPanel'));
  };

  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full border border-gray-200 dark:border-gray-700 animate-in fade-in zoom-in duration-200">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
              <Bell className="w-5 h-5 text-red-600 dark:text-red-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Okunmamış Bildirimler
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {unreadCount} {unreadCount === 1 ? 'bildirim' : 'bildirim'} okunmadı
              </p>
            </div>
          </div>
          <button
            onClick={dismissReminder}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
            aria-label="Kapat"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Okunmamış bildirimleriniz var. Bildirimleri görüntülemek ister misiniz?
          </p>
        </div>

        {/* Actions */}
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row gap-2">
          <button
            onClick={handleViewNotifications}
            className="flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium text-sm transition-colors flex items-center justify-center space-x-2"
          >
            <Bell className="w-4 h-4" />
            <span>Bildirimleri Görüntüle</span>
          </button>
          <button
            onClick={dismissReminder}
            className="flex-1 px-4 py-2.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg font-medium text-sm transition-colors flex items-center justify-center space-x-2"
          >
            <Clock className="w-4 h-4" />
            <span>Daha Sonra Hatırlat</span>
          </button>
          <button
            onClick={dismissReminderForToday}
            className="flex-1 px-4 py-2.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg font-medium text-sm transition-colors flex items-center justify-center space-x-2"
          >
            <Calendar className="w-4 h-4" />
            <span>Bugün Hatırlatma</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnreadNotificationReminder;

